export default __webpack_public_path__ + "static/media/dimmer.31c1e5a4.svg";